import React, { FC } from 'react';
import { Typography } from '@design-system/typography';

interface ReviewsSectionProps {
  disclaimer: string;
}

const ReviewsSection: FC<ReviewsSectionProps> = ({ disclaimer }) => (
  <div className="reviews-section">
    <div className="reviews-section__content">
      <Typography
        content={disclaimer}
        variant="body"
        size="m"
        className="reviews-section__disclaimer"
      />
    </div>
  </div>
);

export default ReviewsSection;
